//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfHeading from "~/themes/fiskarsMoominDefault/components/components/atoms/SfHeading/SfHeading.vue";
import MoominWaveDivider from "../../atoms/MoominWaveDivider/MoominWaveDivider.vue";
import MoominCharactersList from "../../molecules/MoominCharactersList/MoominCharactersList.vue";
import SfCarousel from "../SfCarousel/SfCarousel.vue";

export default {
  name: "MoominExploreCharacters",
  components: {
    MoominWaveDivider,
    SfButton,
    SfHeading,
    SfCarousel,
    MoominCharactersList,
  },
  data() {
    return {
      selectedCharacterIndex: 0,
      carouselOptions: {
        type: "carousel",
        rewind: true,
        perView: 4,
        slidePerPage: true,
        gap: 0,
        breakpoints: {
          1023: {
            gap: 1,
            perView: 4,
            peek: {
              before: 0,
              after: 0,
            },
          },
        },
      },
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    background: {
      type: String,
      default: "var(--c-secondary-sand)",
    },
    navigationButtonText: {
      type: String,
      default: "",
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    characterList: {
      type: Array,
      default: () => [],
      validator: (characterList) => {
        if (!characterList || !characterList.length) return true;

        const keysNeeded = ["characterName", "image"];

        return characterList.every((char) => {
          return keysNeeded.every((key) => {
            return typeof char[key] != "undefined";
          });
        });
      },
    },
  },
  methods: {
    selectCharacter(event) {
      this.selectedCharacterIndex = event;
    },
  },
};
